export const decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives";
